import Item from './Item.js';
import { globalItemDataStore } from '../OverworldAnimation.js';

/** Berry item (status, HP/PP, EV reduction, pinch). Can be used like healing items or consumed when held below HP %. */
export default class Berry extends Item {
    constructor({ id, name, description, price, overworldOptions, battleOptions, healAmount, healStatus, berryConsumeHpPercent } = {}) {
        const data = id ? globalItemDataStore[id] : {};
        super({
            id,
            name: name ?? data?.name,
            description: description ?? data?.description,
            price: price ?? data?.price,
            overworldOptions: overworldOptions ?? data?.overworldOptions ?? ['Use', 'Give', 'Cancel'],
            battleOptions: battleOptions ?? data?.battleOptions ?? ['Use', 'Cancel'],
        });
        this.healAmount = healAmount ?? data?.healAmount ?? 0;
        this.healStatus = healStatus ?? data?.healStatus ?? [];
        this.berryConsumeHpPercent = berryConsumeHpPercent ?? data?.berryConsumeHpPercent ?? null;
    }
}
